import type { DogBreederLastConnectedTypeEnum } from '@gql/graphql';
import type { HTMLAttributes, MouseEventHandler, ReactNode } from 'react';

export interface ContactInfoValue {
  label: string;
  value?: ReactNode;
}

export interface ContactInfoData {
  profileImage?: string;
  values?: ContactInfoValue[];
  onClick?: MouseEventHandler;
  onContactClick?: MouseEventHandler;
  onWriteReviewClick?: MouseEventHandler;
  onSendMessageClick?: MouseEventHandler;
  on?: MouseEventHandler;
  showReviewButton?: boolean;
  showSendMessageButton?: boolean;
  lastConnectedType?: DogBreederLastConnectedTypeEnum;
  onApplyClick?: MouseEventHandler;
}

export interface ContactInfoProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>,
    ContactInfoData {
  buttons?: ReactNode[];
}
